import { Component, ReactNode } from "react";
import { withTranslation } from "react-i18next";
import { WithTFunction } from "src/types/WithTFunction";

class Home extends Component<WithTFunction<{}>> {
  componentDidMount(): void {
    window.location.replace("https://minddrops.de/app");
  }
  render(): ReactNode {
    return <section />;
  }
}

export default withTranslation()(Home);
